angular.module('wbControllers').controller 'SessionCountdownController',
['$scope', '$rootScope', '$resource', '$window', 'sessionExpiryService', '$timeout', 'Session',
($scope, $rootScope, $resource, $window, sessionExpiryService, $timeout, Session) ->
  @showWarning = false
  @state = 'init'

  Notification.requestPermission() if $scope.auth.hasRole('staff') and !window.isMobile

  @stayLoggedIn = ->
    @state = 'extending-session'
    Session.get().$promise
      .then =>
        @showWarning = false
        @state = 'success'
      .catch => @logout()
    adminNotification.close() if adminNotification

  $rootScope.$on '$routeChangeSuccess', =>
    Session.get().$promise
      .catch => @logout()

  @logout = ->
    $window.location.href = "/logout"

  warningTimeout = null
  adminNotification = null
  sessionBuffer = 10
  warningTime = 120
  title = document.title

  $rootScope.$on 'sessionExpiryUpdated', (e, expiry) =>
    return unless expiry?

    document.title = title

    @countdown = moment().add(expiry.expiresIn - sessionBuffer, 's')
    warnIn = (expiry.expiresIn - warningTime - sessionBuffer) * 1000
    $timeout.cancel(warningTimeout)

    warningTimeout = $timeout =>
      @showWarning = true
      document.title = "CI Direct Investing - *"

      if $scope.auth.hasRole('staff')
        adminNotification = new Notification('CI Direct Investing Notification', {
          body: 'Your session will expire in two minutes.',
          icon: '/apple-touch-icon.png'
        })

    , warnIn

  @
]
